import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const QuadLuxPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const experiences = [
    {
      icon: 'ri-building-fill',
      title: 'Balade Urbaine Paris',
      duration: '1h30 - 2h',
      description: 'Découvrez Paris autrement à bord de nos quads électriques. Tour Eiffel, Champs-Élysées, Arc de Triomphe... Une aventure unique au cœur de la capitale.',
      price: 'À partir de 89€',
      features: ['Guide professionnel', 'Photos GoPro incluses', 'Casque fourni', 'Assurance comprise'],
      image: 'https://public.readdy.ai/ai/img_res/a40b46d13fab6cba857398efd046c2ec.jpg',
      color: 'from-orange-500 to-amber-500'
    },
    {
      icon: 'ri-landscape-fill',
      title: 'Randonnée Nature Vexin',
      duration: '2h - 3h',
      description: 'Évadez-vous dans les paysages préservés du Vexin Français. Forêts, vallées et panoramas exceptionnels vous attendent pour une aventure nature inoubliable.',
      price: 'À partir de 119€',
      features: ['Parcours tout-terrain', 'Vidéo drone incluse', 'Pause panoramique', 'Équipement complet'],
      image: 'https://readdy.ai/api/search-image?query=electric%20quad%20bike%20adventure%20in%20French%20countryside%20nature%2C%20ATV%20riding%20through%20forest%20trails%2C%20outdoor%20quad%20exploration%20in%20Vexin%20region%2C%20scenic%20nature%20adventure%20with%20electric%20vehicle%2C%20professional%20outdoor%20photography%2C%20beautiful%20landscape%20with%20quad%2C%20thrilling%20off-road%20experience%2C%20green%20forest%20adventure%2C%20dynamic%20action%20shot&width=800&height=600&seq=vybe-quad-nature-001&orientation=landscape',
      color: 'from-green-500 to-emerald-500'
    },
    {
      icon: 'ri-sun-fill',
      title: 'Sunset Tour Exclusif',
      duration: '2h30',
      description: 'Vivez la magie du coucher de soleil sur Paris ou en pleine nature. Une expérience romantique et spectaculaire avec champagne et photos professionnelles.',
      price: 'À partir de 159€',
      features: ['Heure dorée garantie', 'Champagne offert', 'Shooting photo pro', 'Itinéraire premium'],
      image: 'https://readdy.ai/api/search-image?query=romantic%20sunset%20quad%20bike%20tour%20in%20Paris%2C%20golden%20hour%20ATV%20adventure%20with%20Eiffel%20Tower%2C%20luxury%20sunset%20experience%20on%20electric%20quad%2C%20beautiful%20evening%20ride%20through%20Paris%2C%20cinematic%20sunset%20photography%2C%20premium%20outdoor%20adventure%20at%20dusk%2C%20champagne%20celebration%20on%20quad%20tour%2C%20sophisticated%20travel%20experience&width=800&height=600&seq=vybe-quad-sunset-001&orientation=landscape',
      color: 'from-rose-500 to-pink-500'
    },
    {
      icon: 'ri-gift-fill',
      title: 'Bon Cadeau Aventure',
      duration: 'Flexible',
      description: 'Offrez une expérience unique et mémorable. Nos bons cadeaux sont valables 1 an et personnalisables pour toutes occasions.',
      price: 'À partir de 89€',
      features: ['Valable 1 an', 'Personnalisable', 'Envoi immédiat', 'Toutes formules'],
      image: 'https://readdy.ai/api/search-image?query=luxury%20gift%20voucher%20for%20adventure%20experience%2C%20elegant%20gift%20certificate%20design%2C%20premium%20experience%20gift%20card%2C%20sophisticated%20present%20for%20outdoor%20adventure%2C%20stylish%20gift%20box%20with%20ribbon%2C%20high-end%20travel%20gift%2C%20beautiful%20gift%20presentation%2C%20professional%20product%20photography&width=800&height=600&seq=vybe-quad-gift-001&orientation=landscape',
      color: 'from-purple-500 to-indigo-500'
    }
  ];

  const pricing = [
    {
      name: 'Découverte',
      duration: '1h30',
      price: '89€',
      features: ['1 personne', 'Paris ou Nature', 'Photos GoPro', 'Guide expert', 'Assurance'],
      popular: false
    },
    {
      name: 'Aventure',
      duration: '2h',
      price: '119€',
      features: ['1-2 personnes', 'Parcours étendu', 'Photos + Vidéo drone', 'Guide expert', 'Assurance', 'Pause panoramique'],
      popular: true
    },
    {
      name: 'Premium',
      duration: '2h30',
      price: '159€',
      features: ['1-2 personnes', 'Sunset Tour', 'Shooting photo pro', 'Champagne offert', 'Guide expert', 'Assurance', 'Souvenirs premium'],
      popular: false
    },
    {
      name: 'Groupe',
      duration: '2h',
      price: 'Sur devis',
      features: ['4+ personnes', 'Itinéraire personnalisé', 'Team building', 'Photos & vidéos', 'Guides multiples', 'Assurance', 'Organisation complète'],
      popular: false
    }
  ];

  const safetyInfo = [
    { icon: 'ri-shield-check-fill', title: 'Assurance Complète', desc: 'Tous nos participants sont couverts' },
    { icon: 'ri-user-star-fill', title: 'Guides Certifiés', desc: 'Professionnels expérimentés et passionnés' },
    { icon: 'ri-tools-fill', title: 'Matériel Premium', desc: 'Quads électriques neufs et entretenus' },
    { icon: 'ri-first-aid-kit-fill', title: 'Sécurité Maximale', desc: 'Briefing complet et équipement fourni' },
    { icon: 'ri-leaf-fill', title: '100% Électrique', desc: 'Zéro émission, respect de l\'environnement' },
    { icon: 'ri-camera-fill', title: 'Souvenirs Inclus', desc: 'Photos et vidéos de votre aventure' }
  ];

  const gallery = [
    {
      image: 'https://readdy.ai/api/search-image?query=group%20of%20friends%20on%20electric%20quad%20bikes%20in%20Paris%2C%20happy%20people%20enjoying%20ATV%20tour%2C%20fun%20outdoor%20adventure%20activity%2C%20exciting%20city%20exploration%2C%20professional%20group%20photography%2C%20dynamic%20action%20shot%2C%20joyful%20experience%2C%20urban%20adventure&width=600&height=400&seq=vybe-quad-gallery-001&orientation=landscape',
      title: 'Aventure en Groupe'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=electric%20quad%20bike%20with%20Eiffel%20Tower%20background%2C%20iconic%20Paris%20landmark%20view%20from%20ATV%2C%20stunning%20cityscape%20photography%2C%20premium%20urban%20tour%2C%20professional%20travel%20photography%2C%20golden%20hour%20lighting%2C%20sophisticated%20adventure&width=600&height=400&seq=vybe-quad-gallery-002&orientation=landscape',
      title: 'Paris Iconique'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=quad%20bike%20riding%20through%20beautiful%20forest%20trail%2C%20nature%20adventure%20in%20French%20countryside%2C%20scenic%20outdoor%20exploration%2C%20green%20landscape%20with%20ATV%2C%20professional%20nature%20photography%2C%20peaceful%20forest%20adventure&width=600&height=400&seq=vybe-quad-gallery-003&orientation=landscape',
      title: 'Nature Préservée'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=couple%20on%20romantic%20quad%20bike%20sunset%20tour%2C%20intimate%20adventure%20experience%2C%20beautiful%20golden%20hour%20photography%2C%20romantic%20outdoor%20activity%2C%20professional%20couple%20photography%2C%20scenic%20sunset%20background&width=600&height=400&seq=vybe-quad-gallery-004&orientation=landscape',
      title: 'Moments Romantiques'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=action%20shot%20of%20electric%20quad%20bike%20in%20motion%2C%20dynamic%20ATV%20photography%2C%20thrilling%20adventure%20moment%2C%20professional%20sports%20photography%2C%20exciting%20outdoor%20activity%2C%20speed%20and%20movement&width=600&height=400&seq=vybe-quad-gallery-005&orientation=landscape',
      title: 'Sensations Fortes'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=panoramic%20view%20from%20quad%20bike%20tour%2C%20breathtaking%20landscape%20vista%2C%20scenic%20overlook%20photography%2C%20beautiful%20nature%20panorama%2C%20professional%20landscape%20photography%2C%20stunning%20viewpoint&width=600&height=400&seq=vybe-quad-gallery-006&orientation=landscape',
      title: 'Vues Spectaculaires'
    }
  ];

  return (
    <div className="min-h-screen bg-[#0A0A0A]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/60 via-[#0A0A0A]/80 to-[#0A0A0A] z-10"></div>
            <img
              src="https://readdy.ai/api/search-image?query=electric%20quad%20bike%20adventure%20in%20Paris%20streets%2C%20modern%20ATV%20urban%20exploration%20near%20Eiffel%20Tower%2C%20exciting%20city%20tour%20on%20electric%20quad%2C%20premium%20outdoor%20adventure%20activity%2C%20dynamic%20action%20photography%20of%20quad%20riding%2C%20urban%20landscape%20exploration%2C%20thrilling%20Paris%20experience%2C%20professional%20adventure%20photography%2C%20stylish%20electric%20vehicle%20tour&width=1920&height=1080&seq=vybe-quad-hero-main-001&orientation=landscape"
              alt="VYBE BY QUAD"
              className="w-full h-full object-cover animate-slow-zoom"
              loading="eager"
            />
          </div>

          <div className="absolute inset-0 pointer-events-none z-20">
            <div className="absolute top-20 right-10 w-24 h-24 bg-gradient-to-br from-orange-500/30 to-amber-500/30 rounded-full blur-2xl animate-float"></div>
            <div className="absolute bottom-40 left-20 w-32 h-32 bg-gradient-to-br from-yellow-500/20 to-orange-500/20 rounded-full blur-3xl animate-float-delayed"></div>
          </div>

          <div className="relative z-30 text-center px-4 max-w-6xl mx-auto">
            <div className="mb-8 animate-fade-in-up">
              <div className="inline-block px-8 py-3 bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mb-6">
                <span className="text-white font-bold text-sm tracking-wider flex items-center gap-2">
                  <i className="ri-riding-fill text-xl"></i>
                  AVENTURE URBAINE & NATURE
                </span>
              </div>
              
              <h1 className="text-6xl md:text-8xl lg:text-9xl font-black mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                <span className="bg-gradient-to-r from-orange-400 via-amber-400 to-yellow-400 bg-clip-text text-transparent">
                  VYBE BY QUAD
                </span>
              </h1>
              
              <p className="text-2xl md:text-4xl text-white/90 mb-8 font-light">
                L'aventure électrique au cœur de Paris
              </p>
              
              <p className="text-lg md:text-xl text-white/70 max-w-3xl mx-auto mb-12">
                Balades en quad électrique dans Paris et randonnées nature. 
                Expériences uniques avec photos GoPro et vidéos drone incluses.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 justify-center animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
              <a
                href="#booking"
                className="group px-10 py-5 bg-gradient-to-r from-orange-500 via-amber-500 to-yellow-500 text-white font-bold rounded-2xl hover:scale-105 transition-all duration-500 shadow-2xl hover:shadow-orange-500/50"
              >
                <span className="flex items-center gap-3">
                  <i className="ri-calendar-check-fill text-2xl"></i>
                  Réserver Maintenant
                  <i className="ri-arrow-right-line text-xl group-hover:translate-x-2 transition-transform"></i>
                </span>
              </a>
              
              <a
                href="#experiences"
                className="group px-10 py-5 bg-white/10 backdrop-blur-xl text-white font-bold rounded-2xl border border-white/20 hover:scale-105 transition-all duration-500 hover:bg-white/20"
              >
                <span className="flex items-center gap-3">
                  <i className="ri-map-pin-fill text-2xl"></i>
                  Découvrir les Parcours
                </span>
              </a>
            </div>
          </div>

          <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 z-30 animate-bounce">
            <div className="w-14 h-14 rounded-full border-2 border-orange-400 flex items-center justify-center bg-[#0A0A0A]/50 backdrop-blur-sm">
              <i className="ri-arrow-down-line text-orange-400 text-2xl"></i>
            </div>
          </div>
        </section>

        {/* Experiences Section */}
        <section id="experiences" className="py-32 px-4 bg-gradient-to-b from-[#0A0A0A] to-[#0F0F0F]">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-20">
              <span className="text-orange-400 text-sm font-bold tracking-widest uppercase">Nos Aventures</span>
              <h2 className="text-5xl md:text-7xl font-black text-white mt-4 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Choisissez votre <span className="bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">Expérience</span>
              </h2>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {experiences.map((exp, idx) => (
                <div
                  key={exp.title}
                  className="group relative animate-fade-in-up opacity-0"
                  style={{ animationDelay: `${idx * 0.1}s` }}
                >
                  <div className={`absolute -inset-1 bg-gradient-to-r ${exp.color} opacity-0 group-hover:opacity-75 blur-xl transition-opacity duration-500 rounded-3xl`}></div>
                  
                  <div className="relative overflow-hidden rounded-3xl">
                    <div className="relative h-80">
                      <img
                        src={exp.image}
                        alt={exp.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/50 to-transparent"></div>
                      
                      <div className={`absolute top-6 right-6 px-6 py-3 bg-gradient-to-r ${exp.color} rounded-full`}>
                        <span className="text-white font-bold text-sm">{exp.price}</span>
                      </div>

                      <div className={`absolute top-6 left-6 w-16 h-16 rounded-2xl bg-gradient-to-br ${exp.color} flex items-center justify-center`}>
                        <i className={`${exp.icon} text-3xl text-white`}></i>
                      </div>
                    </div>
                    
                    <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl p-8 border-t border-white/20">
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-3xl font-bold text-white" style={{ fontFamily: 'Poppins, sans-serif' }}>
                          {exp.title}
                        </h3>
                        <span className="text-orange-400 font-bold">{exp.duration}</span>
                      </div>
                      
                      <p className="text-white/70 mb-6 leading-relaxed">
                        {exp.description}
                      </p>
                      
                      <div className="grid grid-cols-2 gap-3">
                        {exp.features.map((feature) => (
                          <div key={feature} className="flex items-center gap-2 text-white/60 text-sm">
                            <i className="ri-checkbox-circle-fill text-orange-400"></i>
                            <span>{feature}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing Section */}
        <section className="py-32 px-4 bg-[#0F0F0F]">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-20">
              <span className="text-orange-400 text-sm font-bold tracking-widest uppercase">Tarifs</span>
              <h2 className="text-5xl md:text-7xl font-black text-white mt-4 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Nos <span className="bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">Formules</span>
              </h2>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {pricing.map((plan, idx) => (
                <div
                  key={plan.name}
                  className={`relative group ${plan.popular ? 'lg:-mt-8' : ''}`}
                >
                  {plan.popular && (
                    <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 px-6 py-2 bg-gradient-to-r from-orange-500 to-amber-500 rounded-full z-10">
                      <span className="text-white font-bold text-sm">⭐ POPULAIRE</span>
                    </div>
                  )}
                  
                  <div className={`absolute -inset-1 bg-gradient-to-r from-orange-500 to-amber-500 opacity-0 group-hover:opacity-75 blur-xl transition-opacity duration-500 rounded-3xl ${plan.popular ? 'opacity-50' : ''}`}></div>
                  
                  <div className={`relative bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-3xl p-8 border ${plan.popular ? 'border-orange-500/50' : 'border-white/20'} hover:scale-105 transition-all duration-500 h-full`}>
                    <h3 className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      {plan.name}
                    </h3>
                    
                    <div className="text-orange-400 font-bold mb-2">{plan.duration}</div>
                    
                    <div className="text-5xl font-black text-white mb-8">
                      {plan.price}
                    </div>
                    
                    <ul className="space-y-4 mb-8">
                      {plan.features.map((feature) => (
                        <li key={feature} className="flex items-start gap-3 text-white/70">
                          <i className="ri-checkbox-circle-fill text-orange-400 mt-1"></i>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                    
                    <a
                      href="#booking"
                      className={`block text-center px-8 py-4 ${plan.popular ? 'bg-gradient-to-r from-orange-500 to-amber-500' : 'bg-white/10 border border-white/20'} text-white font-bold rounded-2xl hover:scale-105 transition-all duration-300`}
                    >
                      Réserver
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Safety Section */}
        <section className="py-32 px-4 bg-gradient-to-b from-[#0F0F0F] to-[#0A0A0A]">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-20">
              <h2 className="text-5xl md:text-7xl font-black text-white mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Sécurité & <span className="bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">Qualité</span>
              </h2>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {safetyInfo.map((info, idx) => (
                <div
                  key={info.title}
                  className="group text-center p-8 bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-xl rounded-2xl border border-white/20 hover:scale-105 transition-all duration-500"
                >
                  <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-orange-500 to-amber-500 flex items-center justify-center group-hover:rotate-12 transition-transform duration-500">
                    <i className={`${info.icon} text-4xl text-white`}></i>
                  </div>
                  <h4 className="text-xl font-bold text-white mb-3">{info.title}</h4>
                  <p className="text-white/70">{info.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Gallery Section */}
        <section className="py-32 px-4 bg-[#0A0A0A]">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-20">
              <h2 className="text-5xl md:text-7xl font-black text-white mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Galerie <span className="bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">Aventures</span>
              </h2>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {gallery.map((item, idx) => (
                <div
                  key={item.title}
                  className="group relative overflow-hidden rounded-3xl aspect-[4/3]"
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                    <h4 className="text-xl font-bold text-white">{item.title}</h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Booking CTA */}
        <section id="booking" className="py-32 px-4 bg-gradient-to-b from-[#0A0A0A] to-[#0F0F0F]">
          <div className="max-w-4xl mx-auto text-center">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500 via-amber-500 to-yellow-500 blur-3xl opacity-20"></div>
              
              <div className="relative bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-2xl rounded-3xl p-12 md:p-16 border border-white/20">
                <i className="ri-riding-fill text-6xl text-orange-400 mb-6 inline-block animate-pulse"></i>
                
                <h2 className="text-4xl md:text-6xl font-black text-white mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Prêt pour l'<span className="bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">aventure</span> ?
                </h2>
                
                <p className="text-xl text-white/80 mb-10">
                  Réservez dès maintenant votre expérience quad électrique à Paris ou en nature
                </p>
                
                <div className="flex flex-col sm:flex-row gap-6 justify-center">
                  <Link
                    to="/contact"
                    className="group px-10 py-5 bg-gradient-to-r from-orange-500 via-amber-500 to-yellow-500 text-white font-bold rounded-2xl hover:scale-105 transition-all duration-500 shadow-2xl"
                  >
                    <span className="flex items-center gap-3">
                      <i className="ri-calendar-check-fill text-2xl"></i>
                      Réserver Maintenant
                      <i className="ri-arrow-right-line text-xl group-hover:translate-x-2 transition-transform"></i>
                    </span>
                  </Link>
                  
                  <a
                    href="tel:+33123456789"
                    className="group px-10 py-5 bg-white/10 backdrop-blur-xl text-white font-bold rounded-2xl border border-white/20 hover:scale-105 transition-all duration-500"
                  >
                    <span className="flex items-center gap-3">
                      <i className="ri-phone-fill text-2xl"></i>
                      Appeler Maintenant
                    </span>
                  </a>
                </div>

                <div className="mt-12 pt-12 border-t border-white/20">
                  <p className="text-white/60 mb-4">🎁 Offrez une expérience unique</p>
                  <a
                    href="#experiences"
                    className="inline-flex items-center gap-2 text-orange-400 font-bold hover:gap-4 transition-all"
                  >
                    Découvrir nos bons cadeaux
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <style>{`
        @keyframes slow-zoom {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        
        @keyframes float-delayed {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-30px); }
        }
        
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(50px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-slow-zoom {
          animation: slow-zoom 20s ease-in-out infinite;
        }
        
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        
        .animate-float-delayed {
          animation: float-delayed 8s ease-in-out infinite;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default QuadLuxPage;
